import React from "react";
import { Route } from "react-router-dom";
import { CustomersLoadingDialog } from "./customers-loading-dialog/CustomersLoadingDialog";
import { CustomerEditDialog } from "./customer-edit-dialog/CustomerEditDialog";
import { CustomerDeleteDialog } from "./customer-delete-dialog/CustomerDeleteDialog";
import { CustomersDeleteDialog } from "./customers-delete-dialog/CustomersDeleteDialog";
import { CustomersFetchDialog } from "./customers-fetch-dialog/CustomersFetchDialog";
import { CustomersUpdateStateDialog } from "./customers-update-status-dialog/CustomersUpdateStateDialog";
import { CustomersUIProvider } from "./CustomersUIContext";
import { CustomersCard } from "./CustomersCard";

import AddStaff from '../../../../pages/Staff/Form/AddStaff'
export function CustomersPage({ history }) {
  const customersUIEvents = {
    newCustomerButtonClick: () => {
      history.push("/staff/addstaff/new");
    },
    openEditCustomerDialog: (id) => {
      history.push(`/staff/addstaff/${id}/edit`);
    },
    openDeleteCustomerDialog: (id) => {
      history.push(`/staff/addstaff/${id}/delete`);
    },
    openDeleteCustomersDialog: () => {
      history.push(`/staff/addstaff/deleteCustomers`);
    },
    openFetchCustomersDialog: () => {
      history.push(`/staff/addstaff/fetch`);
    },
    openUpdateCustomersStatusDialog: () => {
      history.push("/staff/addstaff/updateStatus");
    }
  }

  return (
    <CustomersUIProvider customersUIEvents={customersUIEvents}>
      <CustomersLoadingDialog />
      <Route path="/staff/addstaff/new">
        {({ history, match }) => (
          <AddStaff
            show={match != null}
            onHide={() => {
              history.push("/staff/addstaff");
            }}
          />
        )}
      </Route>
     
    
     
      <Route path="/staff/addstaff/:id/delete">
        {({ history, match }) => (
          <CustomerDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/staff/addstaff");
            }}
          />
        )}
      </Route>
      <Route path="/staff/addstaff/fetch">
        {({ history, match }) => (
          <CustomersFetchDialog
            show={match != null}
            onHide={() => {
              history.push("/staff/addstaff");
            }}
          />
        )}
      </Route>
      <Route path="/staff/addstaff/updateStatus">
        {({ history, match }) => (
          <CustomersUpdateStateDialog
            show={match != null}
            onHide={() => {
              history.push("/staff/addstaff");
            }}
          />
        )}
      </Route>
      <CustomersCard />
    </CustomersUIProvider>
  );
}
